import { defineMessages } from 'react-intl';

export default defineMessages({
    bopDetailsOptionPlaceholder: {
        id: 'fnol.bop.views.details.Option',
        defaultMessage: '-- Option --'
    },
    bopDetailsClassCodePlaceholder: {
        id: 'fnol.bop.views.details.Select Class Code',
        defaultMessage: '-- Select Class Code --'
    },
    bopDetailsRoofCoveringPlaceholder: {
        id: 'fnol.bop.views.details.Select Roof Covering Materials',
        defaultMessage: '-- Select Roof Covering Materials --'
    },
    bopDetailsExteriorWallPlaceholder: {
        id: 'fnol.bop.views.details.Select Exterior Wall Material',
        defaultMessage: '-- Select Exterior Wall Material --'
    },
    bopDetailsOccupancyPlaceholder: {
        id: 'fnol.bop.views.details.Select Type of Occupancy',
        defaultMessage: '-- Select Type of Occupancy --'
    },
    bopDetailsLossAreaPlaceholder: {
        id: 'fnol.bop.views.details.Select Loss Area',
        defaultMessage: '-- Select Loss Area --'
    }
});
